import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

interface StatusIndicatorValue {
  statusText: string;
  statusColor: string;
  isLabel: boolean;
}

@Component({
  selector: 'app-status-indicator-cell-renderer',
  templateUrl: './status-indicator-cell-renderer.component.html',
  styleUrls: ['./status-indicator-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusIndicatorCellRendererComponent implements ICellRendererAngularComp {
  statusText: string = '';
  statusColor: string = '';
  isLabel: boolean = true;

  agInit(params: ICellRendererParams): void {
    this.setValue(params.value as StatusIndicatorValue);
  }

  refresh(params: ICellRendererParams): boolean {
    this.setValue(params.value as StatusIndicatorValue);
    return true;
  }

  private setValue(value: StatusIndicatorValue): void {
    this.statusText = value?.statusText || '';
    this.statusColor = value?.statusColor || '';
    this.isLabel = value?.isLabel !== false;
  }
}
